<template>
  <div class="d-flex justify-end">
    <v-btn icon tile v-if="canRead && !canUpdate">
      <v-icon size="18">visibility</v-icon>
    </v-btn>
    <!-- Update -->
    <template v-if="canRead && canUpdate">
      <update-item-custom
        v-if="isEditCustomView"
        :service="service"
        :itemId="itemId"
        @updateTableItem="updateTableItem($event)"
        :dialogLargeSize="dialogLargeSize"
        :dialogModelTitle="dialogModelTitle"
        :view="getEditCustomView()"
      />
      <update-item
        v-else
        :service="service"
        :itemId="itemId"
        @updateTableItem="updateTableItem($event)"
        :dialogLargeSize="dialogLargeSize"
        :dialogModelTitle="dialogModelTitle"
      />
    </template>

    <v-menu
      v-if="
        canDelete ||
        canArchive ||
        canClone ||
        customActionsUrl ||
        customActionsLink ||
        customActionsFunction
      "
      offset-x
      left
      close-on-click
    >
      <template v-slot:activator="{ on }">
        <v-btn tile icon v-on="on">
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <!-- Delete -->
        <v-list-item v-if="canDelete" @click.stop="deleteItem(itemRowNode)">
          <v-list-item-icon>
            <v-icon>delete_forever</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Eliminar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Archive -->
        <v-list-item v-if="canArchive">
          <v-list-item-icon>
            <v-icon>archive</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Arxivar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Clone -->
        <clone-item
          v-if="canClone"
          :service="service"
          :itemId="itemId"
          @createTableItem="createTableItem"
          :dialogModelTitle="dialogModelTitle"
        />

        <!-- Custom actions Router Link -->
        <template v-if="customActionsLink">
          <v-list-item
            v-for="action in customActionsLink"
            :key="action.name"
            :to="{ name: action.name, params: action.params }"
            :target="action.target"
          >
            <v-list-item-icon>
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <!-- Custom actions custom Function -->
        <template v-if="customActionsFunction">
          <v-list-item
            v-for="action in customActionsFunction"
            :key="action.name"
            @click.stop="customFunction(action.name, action.params)"
          >
            <v-list-item-icon>
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <!-- Custom actions URL -->
        <template v-if="customActionsUrl">
          <v-list-item
            v-for="action in customActionsUrl"
            :key="action.name"
            :href="action.url"
            :target="action.target"
          >
            <v-list-item-icon>
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Vue from "vue"
import UpdateItem from "@/components/crud_ag/actions/Update.vue"
import CloneItem from "@/components/crud_ag/actions/Clone.vue"
import UpdateCustom from "@/components/crud_ag/actions/UpdateCustom.vue"

export default Vue.extend({
  components: {
    "update-item-custom": UpdateCustom,
    "update-item": UpdateItem,
    "clone-item": CloneItem,
  },
  methods: {
    deleteItem(rowNode) {
      this.params.context.componentParent.deleteItem(rowNode)
    },
    createTableItem(id) {
      this.params.context.componentParent.createTableItem(id)
    },
    updateTableItem() {
      this.params.context.componentParent.updateTableItem(this.itemRowNode)
    },
    customFunction(functionName, args) {
      this.params.context.componentParent.customFunctions[functionName].apply(null, args)
    },
    getEditCustomView() {
      return this.params.context.componentParent.editCustomView
    },
  },
  computed: {
    canRead() {
      return !!this.params.value.read
    },
    canUpdate() {
      return !!this.params.value.update
    },
    isEditCustomView() {
      return !!this.params.context.componentParent.editCustomView
    },
    canDelete() {
      return !!this.params.value.delete
    },
    canArchive() {
      return !!this.params.value.archive
    },
    canClone() {
      return !!this.params.value.clone
    },
    customActionsLink() {
      return this.params.value.custom
        ? this.params.value.custom.filter(action => action.type === "router-link")
        : null
    },
    customActionsFunction() {
      return this.params.value.custom
        ? this.params.value.custom.filter(action => action.type === "function")
        : null
    },
    customActionsUrl() {
      return this.params.value.custom
        ? this.params.value.custom.filter(action => action.type === "url")
        : null
    },
    itemId() {
      return this.params.node.data.id
    },
    itemRowNode() {
      return this.params.node
    },
    service() {
      return this.params.context.componentParent.service
    },
    dialogLargeSize() {
      return this.params.context.componentParent.dialogLargeSize
    },
    dialogModelTitle() {
      return this.params.context.componentParent.modelKeyTitle
    },
  },
})
</script>
